export const CASHBACK_TRAVEL = {
  Header: 'TERMOS E CONDIÇÕES DA CAMPANHA 10% DE CASHBACK RAPPI TRAVEL',
  Body: [
    {
      Title: null,
      Paragraphs: [
        `Por meio desta oferta, divulgamos os Termos e Condições da campanha "10% de Cashback Rappi Travel”, por meio da qual
        todos os usuários que adquirirem produtos e serviços da seção “RAPPI TRAVEL”, disponível na plataforma Rappi, receberão
        cashback de até 10% (dez por cento) do valor em Créditos, para utilizar em compras de produtos da seção Travel.`,
        '"Usuário" para fins deste T&C significa a pessoa humana inscrita na plataforma Rappi.'
      ]
    },
    {
      Title: 'REGRAS PRINCIPAIS DA PROMOÇÃO:',
      Paragraphs: [
        `<ul>
          <li>
            Esta campanha aplica-se aos usuários que adquirirem produtos e serviços da seção “RAPPI TRAVEL”, no aplicativo
            Rappi, no período de <strong>01 de Fevereiro de 2021 às 00:01 até 13 de Fevereiro de 2021 às 23:59</strong>;
          </li>
        </ul>`,
        `<ul>
          <li>
            Campanha válida exclusivamente para as compras feitas pelos usuários nas lojas parceiras disponíveis na plataforma,
            na seção Travel, mediante aplicativo Rappi;
          </li>
        </ul>`,
        `<ul>
          <li>
            O cashback será de até <strong>10% (dez por cento)</strong> por compra, podendo chegar até o limite de
            <strong>R$ 1.200,00 (um mil e duzentos reais)</strong> em Créditos, para serem utilizados em compras futuras;
          </li>
        </ul>`,
        `<ul>
          <li>
            Promoção válida nas áreas de cobertura do aplicativo em todo território brasileiro  - Brasil;
          </li>
        </ul>`,
        `<ul>
          <li>
            Campanha válida somente para pedidos realizados e pagos através dos meios de pagamento: RappiPay, Cartão de crédito
            Visa, Cartão de crédito Mastercard, ELO;
          </li>
        </ul>`,
        `<ul>
          <li>
            Esclarece-se que há o limite de <strong>R$ 1.200,00 (mil e duzentos reais) Créditos</strong> em cashback por
            usuário durante esta Promoção;
          </li>
        </ul>`,
        `<ul>
          <li>
            O cashback concedido é entregue em Créditos e será creditado ao usuário em até 24 (vinte e quatro) horas após
            a conclusão do pedido;
          </li>
        </ul>`,
        `<ul>
          <li>
            Os Créditos concedidos no cashback podem ser utilizados até a data limite de 15 de Março de 2021;
          </li>
        </ul>`,
        `<ul>
          <li>
            Esclarece-se que serão permitidos o limite máximo de até 4 (quatro) compras por usuário durante o período da promoção;
          </li>
        </ul>`,
        `<ul>
          <li>
            Ressalta-se que a presente Campanha é aplicável unicamente para ordens pagas com Cartão de Crédito. Qualquer
            pagamento parcial realizado pelo usuário/consumidor com Créditos ou qualquer outro meio de pagamento diferente
            a Cartão de Crédito, Rappi Pay, Débito e-card ou carteira virtual não será considerado para cálculo da porcentagem de
            devolução do Cashback;
          </li>
        </ul>`,
        `<ul>
          <li>
            A Rappi reserva-se o direito de restringir ou reter os créditos Rappi já concedidos, nos casos em que se verifique
            que o Utilizador / Consumidor adquiriu os produtos e / ou serviços apresentados no Botão Rappi Travel  para fins
            comerciais e não para uso pessoal;
          </li>
        </ul>`,
        `<ul>
          <li>
            Caso o usuário / consumidor efetue a devolução da compra efetuada, no ato do reembolso do produto, o valor do
            Cashback que já foi debitado na conta do utilizador / consumidor por ocasião desta Campanha será deduzido do saldo
            para a favor do Créditos do usuário / consumidor. Caso o usuário / consumidor não tenha saldo de Créditos
            a favor na data do desembolso, o Rappi descontará o valor do cashback que foi concedido do valor total da compra
            inicial realizada pelo usuário / consumidor, sobre o qual se realizará o reembolso;
          </li>
        </ul>`,
        `<ul>
          <li>
            É esclarecido que esta campanha não se aplica a pedidos parcialmente ou totalmente cancelados;
          </li>
        </ul>`,
        `<ul>
          <li>
            Promoção válida SOMENTE nos parceiros disponíveis na Plataforma;
          </li>
        </ul>`,
        `<ul>
          <li>
            Promoção limitada à disponibilidade de 500 (quinhentas) unidades;
          </li>
        </ul>`,
        `<ul>
          <li>
            Promoção não cumulativa;
          </li>
        </ul>`,
        `<ul>
          <li>
            Promoção intransferível.
          </li>
        </ul>`,
      ]
    },
    {
      Title: 'CONDIÇÕES GERAIS DA PROMOÇÃO:',
      Paragraphs: [
        `Promoção válida até a data e hora estipuladas ou enquanto durarem os estoques. Reservamo-nos o direito de cancelar
        qualquer transação que, devido às suas características, viole as condições de elegibilidade a esta promoção.`,
        'Esta promoção é pessoal e intransferível, será aplicada apenas aos usuários que aplicarem a promoção.',
        `A Rappi se reserva o direito de encerrar esta promoção a qualquer momento em caso de fraude ou desviação da doação
        para terceiros.`,
        `O usuário reconhece e aceita que o fornecedor direto dos produtos é o Parceiro Comercial (estabelecimento), uma
        vez que este é o único que exibe, oferece, promove e comercializa produtos para os usuários/consumidores através
        da Plataforma.`,
        `O Usuário reconhece e aceita que as informações fornecidas e registradas na plataforma virtual Rappi são verdadeiras
        e confiáveis, assumindo total responsabilidade por sua falsidade. As informações fornecidas terão o caráter de uma
        declaração juramentada, os Usuários têm total responsabilidade pela autenticidade e veracidade das mesmas, não sendo
        a Rappi responsável, caso o Usuário incorra na omissão e/ou erro no momento do carregamento do dados solicitados
        pelos Usuário para obter os benefícios da Promoção.`,
        `A Rappi se reserva o direito de cancelar a promoção, cancelar o código e bloquear a conta do Usuário a qualquer
        momento, se for determinado que estão ocorrendo fraude ou ação ilícita para obtenção do benefício.`,
        `A Rappi se reserva o direito de modificar as condições ou cancelar esta promoção a qualquer momento e a seu critério
        livre.`,
        `O Rappi não permitirá que o Usuário acesse a promoção quando for verificado que as contas referidas são fictícias
        ou falsas. Usuários que realmente não constituem uma pessoa física identificável por meio de um documento de
        identidade emitido pela autoridade competente.`,
        `A Rappi reserva-se o direito, a seu exclusivo critério, de modificar, alterar ou atualizar estes Termos e Condições
        a qualquer momento. As modificações serão comunicadas no aplicativo Rappi e entrarão em vigor imediatamente a partir
        do momento de sua publicação.`,
        `O Rappi não comercializa produtos, pois é apenas uma plataforma tecnológica de intermediação entre terceiros que
        exibe serviços e produtos aos usuários/consumidores que os adquirem.`,
        'Promoção válida na área de cobertura do Rappi para usuários do Rappi no Brasil.',
        'Promoção não acumulável com outras promoções.',
        `Consulte nossos <a
        href="https://legal.rappi.com/brazil/termos-e-condicoes-de-uso-da-plataforma-rappi/">
        Termos de Uso e Condições da Plataforma Rappi</a> e <a
        href="https://legal.rappi.com/brazil/aviso-de-privacidade-e-politicas-de-uso-das-informacao-utilizadas-pela-rappi/">
        Aviso de Privacidade de Dados</a>.`,
        'São Paulo/SP.',
      ]
    }
  ]
};
